module.exports = __webpack_public_path__ + "img/DerSong.c3a21a5a.svg";